import {
  WaitingListWaitingListWriteModelRole,
  type WaitingListWaitingListWriteModel
} from '@r/api/generated/client.schemas.ts';
import type { WaitingListProposeFormValues } from '@admin/components/company/waiting-list/waiting-list-propose-form-schema.ts';

const STEP_COMPANY_FIELDS_BASE: (keyof WaitingListProposeFormValues)[] = [
  'companyName',
  'companyUniqueCode',
  'tva',
  'siren',
  'addressLine1',
  'addressLine2',
  'zipcode',
  'city',
  'countryAlpha3'
];

export function getWaitingListProposeCompanyStepFields(
  typologyConversionMode: boolean
): (keyof WaitingListProposeFormValues)[] {
  if (typologyConversionMode) return [...STEP_COMPANY_FIELDS_BASE, 'typology'];
  return [...STEP_COMPANY_FIELDS_BASE, 'pointCoeff'];
}

export function buildWaitingListProposePayload(
  values: WaitingListProposeFormValues,
  typologyConversionMode: boolean
): WaitingListWaitingListWriteModel {
  const explicitUnique = values.companyUniqueCode?.trim();
  const fallbackUnique = values.siren?.trim() || values.tva?.trim() || null;

  return {
    companyName: values.companyName?.trim() || null,
    companyUniqueCode: explicitUnique?.length ? explicitUnique : fallbackUnique || null,
    tva: values.tva?.trim() || null,
    siren: values.siren?.trim() || null,
    addressLine1: values.addressLine1?.trim() || null,
    addressLine2: values.addressLine2?.trim() || null,
    addressLine3: null,
    zipcode: values.zipcode?.trim() || null,
    city: values.city?.trim() || null,
    country:
      values.countryAlpha3 && values.countryAlpha3.length === 3
        ? `/countries/${values.countryAlpha3}`
        : null,
    email: values.email?.trim() || null,
    firstname: values.firstname?.trim() || null,
    lastname: values.lastname?.trim() || null,
    userUniqueCode: null,
    role:
      values.role === WaitingListWaitingListWriteModelRole.ROLE_MEMBER ||
      values.role === WaitingListWaitingListWriteModelRole.ROLE_MANAGER
        ? values.role
        : null,
    comment: values.comment?.trim() || null,
    responsible: null,
    typology: typologyConversionMode && values.typology?.trim() ? values.typology.trim() : null,
    pointCoeff:
      !typologyConversionMode &&
      values.pointCoeff !== undefined &&
      values.pointCoeff !== null &&
      !Number.isNaN(Number(values.pointCoeff))
        ? values.pointCoeff
        : null
  };
}
